export default __webpack_public_path__ + "static/media/L1936C.a3937a09.png";